import request from '../request'

export function getList (params, loading) {
  return request({
    url: '/app/order/queryComplaintList',
    method: 'get',
    params,
    loading
  })
}

export function fetchDetail (params) {
  return request({
    url: '/app/order/queryComplaint',
    method: 'get',
    params
  })
}
